import React, { useEffect, useState } from "react";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DonateTab from "./components/DonateTabs";
import AddCampaign from "./AddCampaign";
import CampaignCard from "./components/CampaignCard";
import { getFormattedTime } from "../../../../util/timeUtility";
import DefaultModal from "../../../../components/DefaultModal/DefaultModal";
import ProgressBar from "./components/ProgressBar";
import { width } from "styled-system";
import Icon from "../../../../components/Icon";
import { showNotification } from "../../../../util/Utility";
import axios from "axios";
import Loader2 from "../../../../components/Loader2";
import PaginationV2 from "../../../../components/Pagination/PaginationV2";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Table } from "react-bootstrap";
import moment from "moment";

const PAST_CAMPAIGNS = "pastCampaigns";
const ADD_CAMPAIGN = "addCampaign";

const PAGE_SIZE = 6;

const users = [
  { id: 1, firstName: "Alice", lastName: "Smith", username: "alice_s" },
  { id: 2, firstName: "Bob", lastName: "Johnson", username: "bob_j" },
  { id: 3, firstName: "Charlie", lastName: "Brown", username: "charlie_b" },
];

function DonateListPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(PAST_CAMPAIGNS);
  const [shouldReorder, setShouldReoder] = useState(false);
  const [clickedCard, setClickedCard] = useState(null);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const user = useSelector((state) => state?.appReducer?.user);
  const [showDonorDetails, setShowDonorDetails] = useState(false);
  const [donors, setDonors] = useState([]);

  const [campaigns, setCampaigns] = useState([]);

  // Handle drag end event
  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // Check if dropped outside the list
    if (!destination) {
      return;
    }

    // Reorder the campaigns array
    const reorderedCampaigns = Array.from(campaigns);
    const [movedCampaign] = reorderedCampaigns.splice(source.index, 1);
    reorderedCampaigns.splice(destination.index, 0, movedCampaign);

    setCampaigns(reorderedCampaigns);
  };

  const getContent = () => {
    if (activeTab === PAST_CAMPAIGNS)
      return (
        <div className="donate-cards-container">
          {campaigns.length > 0 ? (
            campaigns.map((campaign) => (
              <CampaignCard
                setClickedCard={setClickedCard}
                data={campaign}
                setShowTrackModal={setShowTrackModal}
              />
            ))
          ) : (
            <p>{t("Nothing to see here..")}</p>
          )}
        </div>
      );
    else return <AddCampaign campaign={clickedCard} />;
  };
  useEffect(() => {
    const getCampaigns = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}donation/list?entity_id=${activeEntity?._id}&page=${currentPage}&limit=${PAGE_SIZE}`
        );
        setCampaigns(res.data?.campaigns);
        setTotalCount(res.data?.count);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
        showNotification("error", "some error occured");
      }
    };
    getCampaigns();
  }, [currentPage, activeEntity?._id]);

  useEffect(() => {
    if (clickedCard !== null && !showTrackModal) setActiveTab(ADD_CAMPAIGN);
    if (clickedCard !== null && showTrackModal) {
      setShowDonorDetails(false)
      const getCampaignsPayments = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}donation/donation-payments?campaignId=${clickedCard._id}`
          );
          if(res.status === 200){
            console.log(res.data); 
            setDonors(res.data)
            
          }
        } catch (error) {
          console.log(error);
          showNotification("error", "some error occured");
        }
      };
      getCampaignsPayments();
    }
  }, [clickedCard, showTrackModal]);

  useEffect(() => {
    if (activeTab === PAST_CAMPAIGNS) setClickedCard(null);
  }, [activeTab]);

const getLatestDate = (donorDates)=>{
  donorDates.sort().reverse()
  return moment(donorDates[0]).format('DD/MM/YYYY')
}

  return (
    <div className="donateListContainer" style={{ padding: "7px 40px" }}>
      <DonateTab
        activeTab={activeTab}
        shouldReorder={shouldReorder}
        setShouldReoder={setShouldReoder}
        setActiveTab={setActiveTab}
      />
      {isLoading ? (
        <Loader2 />
      ) : (
        <main style={{ marginBottom: "40px" }}>{getContent()}</main>
      )}
      <DefaultModal
        show={showTrackModal}
        onHide={() => {
          setShowTrackModal(false);
          setClickedCard(null);
        }}
        className="congrats-modal"
        style={{ paddingRight: "0px", width: "600px" }}
        size={"lg"}
        centered={false}
        showHeader={false}
        showFooter={false}
      >
        <div
          style={{ float: "right" }}
          onClick={() => {
            setShowTrackModal(false);
            setClickedCard(null);
          }}
        >
          <Icon
            // style={{zIndex: 2000}}
            iconName="blackCross"
          />
        </div>
        <div style={{ padding: "20px" }}>
          <p
            style={{
              textAlign: "center",
              fontSize: "22px",
              fontWeight: 600,
              color: "#1a1a1a",
            }}
          >
            {t('Track Campaign Details')}
          </p>
          <p style={{fontSize:'18px',color:'#7E7E7E', fontWeight:500}} className="text-center">{t('Hemiska lajalig man mot respektive klimatflykting Du kan vara drabbad')}</p>
          <ProgressBar
            donationCollected={clickedCard?.recievedDonation || 0}
            goalAmount={clickedCard?.amount || 0}
            totalDonors={clickedCard?.user_ids.length || 0}
            highestDonation={clickedCard?.higest_donation || 0}
            title={clickedCard?.title || "NA"}
          />
          <div className="view-donor-details">
            {showDonorDetails ? (
              <div>
                <div className="view-donor-list">
                  <Table className="table-no-borders">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>{t('Donation Date')}</th>
                        <th>{t('Donor Name')}</th>
                        <th>{t("Amount")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {donors.map((donor,i) => (
                        <tr key={donor._id}>
                          <td>{i+1}</td>
                          <td>{getLatestDate(donor.updateHistory)}</td>
                          <td>{donor.isAnonymous?t('Anonymous'):(donor.userName || ('Anonymous'))}</td>
                          <td>{donor.amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                <div className="view-donor-link">
                  <span
                    role="button"
                    onClick={() => setShowDonorDetails(false)}
                  >
                    {t("Hide Donor Details")}
                  </span>
                  <Icon
                    onClick={() => setShowDonorDetails(false)}
                    iconName="arrowUp"
                  />
                </div>
              </div>
            ) : (
              <div role="button" className="view-donor-link">
                <span role="button" onClick={() => setShowDonorDetails(true)}>
                  {t("View Donor Details")}
                </span>
                <Icon
                  onClick={() => setShowDonorDetails(true)}
                  iconName="arrowDown"
                />
              </div>
            )}
          </div>
        </div>
      </DefaultModal>
      {activeTab === PAST_CAMPAIGNS && (
        <PaginationV2
          currentPage={currentPage}
          pageSize={PAGE_SIZE}
          totalCount={totalCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </div>
  );
}

export default DonateListPage;
